import { createContext } from "react";

export const ProjectMenuContext = createContext(null);
